import { useEffect, useState } from 'react';
import styles from '@features/cms/components/collections/DesignersBlock/DesignersBlock.styles';
import DesignerContent from '@features/cms/components/collections/DesignersBlock/DesignerContent';
import { IParsedImage, TImage } from '@components/typescript';
import { useResponsive } from '@features/responsive';
import Button from '@components/Button/Button';
import Icon from '@components/icons/Icon';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  title: string;
  image: TImage;
  description: string;
  buttonText?: string;
  setIsModalOpen?: (boolean) => void;
  active?: boolean;
  isTeam?: boolean;
  thumbnail?: string;
  fullContent?: boolean;
  handleCloseDesigner?: () => void;
  isFirst: boolean;
  email?: string;
  phone?: string;
};
const SingleDesigner = ({
  title,
  image,
  description,
  buttonText = undefined,
  setIsModalOpen = () => null,
  active = true,
  isTeam = false,
  thumbnail = '',
  fullContent = false,
  handleCloseDesigner = () => null,
  isFirst,
  email = undefined,
  phone = undefined
}: PropsType) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const imageSources: IParsedImage = {
    image
  };
  const {
    isWiderThanDesktop,
    isWiderThanMobilelg
  } = useResponsive();
  useEffect(() => {
    setIsMounted(true);
  }, []);
  useEffect(() => {
    if (!isWiderThanMobilelg && isTeam && active) setIsLoaded(true);
  }, [active, isTeam, isWiderThanMobilelg]);

  // NOTE: Temporary solution to avoid server side rendering caused by useResponsive hook
  if (!isMounted) {
    return <div sx={styles.singleDesignerContainer(isLoaded && !!active, !!isTeam)} data-testid="single-designer-container">
        <DesignerContent title={title} description={description} buttonText={buttonText} setIsModalOpen={setIsModalOpen} fullContent={isTeam || fullContent} withSmallTitle={isTeam} isFirst={isFirst} email={email} phone={phone} />
      </div>;
  }
  return <div sx={styles.singleDesignerContainer(isLoaded && !!active, !!isTeam)}>
      {(isWiderThanDesktop && isTeam || !isTeam) && <ResponsiveImage image={imageSources.image} blur={imageSources.blur} alt={title} onLoad={() => setIsLoaded(true)} />}
      <DesignerContent title={title} description={description} buttonText={buttonText} setIsModalOpen={setIsModalOpen} fullContent={isTeam || fullContent} withSmallTitle={isTeam} isFirst={isFirst} email={email} phone={phone} />
      {thumbnail && isMounted && isWiderThanMobilelg && !isWiderThanDesktop && <div sx={styles.designerTabletThubnail}>
          <ResponsiveImage image={thumbnail} alt={title} onLoad={() => setIsLoaded(true)} />
        </div>}
      {isTeam && active && handleCloseDesigner && <span sx={styles.closeButton}>
          <Button variant="iconOnly" onClick={() => handleCloseDesigner()}>
            <Icon icon="Close3" size="24px" />
          </Button>
        </span>}
    </div>;
};
export default SingleDesigner;